module.exports = __webpack_public_path__ + "assets/img/serve6.0dc4dd00.png";